console.log("Conversation Engine Loaded");

const FOLLOWUP_TYPES = {

    BEST: "best",

    CHEAPEST: "cheapest",

    COMPARE: "compare",

    WIFI: "wifi",

    FOUR_G: "4g",

    NIGHT_VISION: "night_vision",

    OUTDOOR: "outdoor",

    INDOOR: "indoor",

    WATERPROOF: "waterproof",

    BATTERY: "battery",

    RECOMMEND: "recommend"

};


function detectFollowUp(message){

    message = message.toLowerCase();

    if(
        message.includes("best") ||
        message.includes("top") ||
        message.includes("highest rated") ||
        message.includes("recommended")
    ){
        return FOLLOWUP_TYPES.BEST;
    }

    if(
        message.includes("cheap") ||
        message.includes("cheapest") ||
        message.includes("lowest")
    ){
        return FOLLOWUP_TYPES.CHEAPEST;
    }

    if(
        message.includes("compare")
    ){
        return FOLLOWUP_TYPES.COMPARE;
    }

    

    return null;

}

//----------------------------------------
// HANDLE FOLLOW-UP QUESTIONS
//----------------------------------------

function handleFollowUpQuestion(message){

    const type = detectFollowUp(message);

    if(!type){
        return false;
    }
    if(!AI_MEMORY.lastProducts.length){

    // No previous products available.
    // Let the normal AI search handle this message.

        return false;

    }

    

    const products = AI_MEMORY.lastProducts;

    //----------------------------------------
    // CHEAPEST
    //----------------------------------------

    if(type === FOLLOWUP_TYPES.CHEAPEST){

        const cheapest = [...products].sort((a,b)=>{

            return parseFloat(a.variants[0].price) -
                   parseFloat(b.variants[0].price);

        })[0];

        addBotMessage(

            "💰 <b>Cheapest Recommendation</b><br><br>" +

            cheapest.title +

            "<br><br>Price : ₹" +

            cheapest.variants[0].price

        );

        showProducts([cheapest]);

        return true;

    }

//----------------------------------------
// BEST
//----------------------------------------

if(type === FOLLOWUP_TYPES.BEST){

    const best = getBestProduct(products);

    const score = calculateProductScore(best);

    let reason = [];

    const text = (
        best.title + " " +
        best.product_type + " " +
        (best.tags || []).join(" ")
    ).toLowerCase();

    if(text.includes("8mp")) reason.push("8MP resolution");
    else if(text.includes("5mp")) reason.push("5MP resolution");
    else if(text.includes("4mp")) reason.push("4MP resolution");
    else if(text.includes("3mp")) reason.push("3MP resolution");
    else if(text.includes("2mp")) reason.push("2MP resolution");

    if(text.includes("4g")) reason.push("4G connectivity");

    if(text.includes("wifi")) reason.push("Wi-Fi support");

    if(text.includes("ai")) reason.push("AI detection");

    if(text.includes("human detection")) reason.push("Human detection");

    if(text.includes("night vision")) reason.push("Night vision");

    if(text.includes("two way") || text.includes("two-way"))
        reason.push("Two-way audio");

    if(text.includes("ptz"))
        reason.push("PTZ control");

    if(text.includes("360"))
        reason.push("360° coverage");

    let reply = "";

    reply += "⭐ <b>Best Recommendation</b><br><br>";

    reply += "<b>" + best.title + "</b><br><br>";

    reply +=
    "I recommend this model because it offers:<br><br>";

    reason.forEach(r=>{

        reply += "✔ " + r + "<br>";

    });

    reply += "<br>";

    reply += "<b>AI Score :</b> " + score;

    addBotMessage(reply);

    showProducts([best]);

    return true;

}

    //----------------------------------------
    // MORE FOLLOW-UPS LATER
    //----------------------------------------

    return false;

}
